import { Card, CardContent, CardHeader } from '@/app/common/components/Card'
import { CurrencyInputField } from '@/app/common/components/currency-input/currency-input'
import { CurrencySchema } from '@/app/common/components/currency-input/currency-input.schema'
import { Input } from '@/common/components/Input.tsx'
import { Label } from '@/shad/ui/label'
import { zodResolver } from '@hookform/resolvers/zod'
import { SubmitHandler, useForm } from 'react-hook-form'
import { useTranslation } from 'react-i18next'
import { z } from 'zod'
import FamilyWizardLayout from '../../../family_application/FamilyWizardLayout'
import { SubmitButton } from '../../../family_application/student_details/shared/submit-button'

const detailSchema = z.object({
  amount: CurrencySchema,
  store_name: z.string().min(1, { message: 'store_name_is_required' }),
})

type FormValues = z.infer<typeof detailSchema>


type Props = { 
  onSubmitSuccess: (data: FormValues) => void
  defaultValues: FormValues
}

export const AddReimbursementDetails = (props: Props) => {
  const { onSubmitSuccess, defaultValues} = props
  const { t: translate } = useTranslation()

  const {
    register,
    handleSubmit,
    formState: { errors },
    getValues,
    setValue,
  } = useForm<FormValues>({
    resolver: zodResolver(detailSchema),
    defaultValues
  })

  const onSubmit: SubmitHandler<FormValues> = async (data: FormValues) => {

    onSubmitSuccess(data)

  }

  return (
    <FamilyWizardLayout>
      <FamilyWizardLayout.Header>
        <h1>{translate('add_details_to_your_receipt')}</h1>
      </FamilyWizardLayout.Header>
      <FamilyWizardLayout.Content className="max-w-80 w-full">
        <Card>
          <CardHeader>
            <p className="w-full text-md font-medium text-gray-800">
              {translate('details')}
            </p>
          </CardHeader>
          <CardContent>
            <form
              id="add-details-form"
              onSubmit={handleSubmit(onSubmit)}
              className="space-y-3"
            >
              <div className="">
                <section
                  className="flex flex-col space-y-2"
                  aria-labelledby="store_name_label"
                >
                  <Label id="store_name_label" htmlFor="store_name">
                    {translate('store_name')}{' '}
                    <span className="text-danger ml-1">*</span>
                  </Label>
                  <div className="relative mt-2 rounded-md shadow-sm">
                    <Input id="store_name" {...register('store_name')} />
                  </div>
                  {errors.store_name && (
                    <p className="mt-1 text-sm text-red-600">
                      {translate(errors.store_name.message ?? '')}
                    </p>
                  )}
                </section>
                <section
                  className="flex flex-col mt-6 space-y-2"
                  aria-labelledby="amount_label"
                >
                  <Label id="amount_label" htmlFor="amount">
                    {translate('amount')}{' '}
                    <span className="text-danger ml-1">*</span>
                  </Label>

                  <CurrencyInputField
                    id="amount"
                    value={getValues('amount')}
                    onChange={(value) => {
                      if (value) {
                        setValue('amount', value)
                      }
                    }}
                  />
                  {errors.amount && (
                    <p className="mt-1 text-sm text-red-600">
                      {translate(errors.amount.message ?? '')}
                    </p>
                  )}
                </section>
              </div>
            </form>
          </CardContent>
        </Card>
      </FamilyWizardLayout.Content>
      <FamilyWizardLayout.ActionBar className="justify-center">
        <div className="flex">
          <SubmitButton
            form="add-details-form"
            status={'idle'}
            buttonTxt={translate('next')}
            className="px-10"
          />
        </div>
      </FamilyWizardLayout.ActionBar>
    </FamilyWizardLayout>
  )
}
